export default __webpack_public_path__ + "94b75061503e2ebb295939f4b7ce848d.png";